"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OFFICERS_METRICS_API_PATH = exports.OFFICERS_LIST_API_PATH = exports.OFFICER_STATUS_UPDATE_URL = exports.OFFICER_STATUS_GET_URL = void 0;
exports.OFFICER_STATUS_GET_URL = 'accounts/officers/get-activity-status/';
exports.OFFICER_STATUS_UPDATE_URL = 'accounts/officers/update-activity-status/';
exports.OFFICERS_LIST_API_PATH = 'accounts/officers/';
exports.OFFICERS_METRICS_API_PATH = 'accounts/officers/metrics/';
